import { Button, Spinner, makeStyles, tokens } from "@fluentui/react-components";
import { useState } from "react";

import { performLogin } from "@entities/user-tokens";

const useStyles = makeStyles({
    overlay: {
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
    },
    modal: {
        backgroundColor: tokens.colorNeutralBackground1,
        borderRadius: tokens.borderRadiusLarge,
        padding: "24px",
        maxWidth: "90%",
        width: "320px",
        boxShadow: tokens.shadow28,
        display: "flex",
        flexDirection: "column",
        gap: "16px",
    },
    title: {
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightSemibold,
        margin: 0,
    },
    message: {
        margin: 0,
        color: tokens.colorNeutralForeground2,
        fontSize: tokens.fontSizeBase200,
    },
    error: {
        color: tokens.colorStatusDangerForeground1,
        fontSize: tokens.fontSizeBase200,
    },
});

export function ReauthPane() {
    const styles = useStyles();
    const [busy, setBusy] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const handleLogin = async () => {
        setBusy(true);
        setErrorMessage(null);
        const outcome = await performLogin();
        setBusy(false);
        if (outcome.ok) return;
        if (outcome.cancelled) return;
        setErrorMessage(`再ログインに失敗しました: ${outcome.detail ?? "unknown"}`);
    };

    return (
        <div
            className={styles.overlay}
            role="dialog"
            aria-modal="true"
            aria-labelledby="reauth-title"
        >
            <div className={styles.modal}>
                <h2 id="reauth-title" className={styles.title}>
                    セッションが切れました
                </h2>
                <p className={styles.message}>
                    安全のため再度ログインが必要です。再ログイン後、操作をやり直してください。
                </p>
                <Button appearance="primary" onClick={handleLogin} disabled={busy}>
                    {busy ? <Spinner size="tiny" label="認証中…" /> : "再ログイン"}
                </Button>
                {errorMessage && <p className={styles.error}>{errorMessage}</p>}
            </div>
        </div>
    );
}
